import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import { cssRaw, media, style } from 'typestyle';

import ContactUsForm from './contactUsForm';
import ContactUsSuccess from './contactUsSucess';
import ContactUsError from './contactUsError';

const inline = style({display: 'inline-block'});
const bottomSpace = style();
const headerBottom = style(
    {marginBottom: '12px !important'},
    media({maxWidth: 990}, {marginBottom: '8px !important'})
);

cssRaw(`
    @media (min-width: 990px) {
        .surveySection {
            margin-top: 24px;
        }
        .addressSection, .questionHeader {
            margin-bottom: 8px;
        }
    }
`);

cssRaw(`
    @media (max-width: 990px) {
        h1 {
            font-size: 20px !important;
            margin-bottom: .2em;
        }
        #requestIcon {
            display: none;
        }
        h2 {
            font-size: 16px !important;
            margin-top: 8px !important;
            margin-bottom: 8px !important;
        }
    }
`);

export enum PageState {
    form = 'form',
    success = 'success',
    error = 'error'
}

const ContactUs: React.FC<{}> = () => {

    const [currentState, setCurrentState] = useState(PageState.form);

    const updateState = (pageState: PageState) => setCurrentState(pageState);    

    const renderCurrentState = () => {
        if (currentState === PageState.form) {
            return <ContactUsForm updateState={ updateState } />;
        } else if (currentState === PageState.success) {
            return <ContactUsSuccess />;
        } else if (currentState === PageState.error) {
            return <ContactUsError />;
        }
    };    

    return <div id='contact-us'>
        <Row>
            <Col lg={4} md={4} sm={12} xs={12}>
                <section>

                    <h1>
                        <img id='requestIcon' src='img/CSS_Icon__Request-a-Quote.png' />
                        <span>Contact Us</span>
                    </h1>

                    <h2>Address</h2>

                    <div className='addressSection'>
                        <div>
                            <span>1625 K Street, NW 8th Floor</span>
                        </div>
                        <div>
                            <span>Washington, DC 20006</span>
                        </div>
                    </div>

                    <div>
                        <div className={inline}>Telephone:</div>
                        <div className={inline}>(202) 347-9612</div>
                    </div>

                    <div className={` ${bottomSpace}`}>
                        <div className={inline}>Email:</div>
                        <div className={inline}>
                            <a href='mailto:info@cssresearch.org?subject=Contact Us'>info@cssresearch.org</a>
                        </div>
                    </div>

                    <div className='surveySection'>
                        <h2 className={headerBottom} >Surveys</h2>
                        <div className='questionHeader'>
                            Have a question about a survey you recieved?
                        </div>
                        <div style={{marginBottom: 17}}>
                            Please email <a href='mailto:questions@cssresearch.org'>questions@cssresearch.org</a> and
                            include the 8-digit reference number on the cover letter between two asterisks(*).
                        </div>
                    </div>
                </section>
            </Col>
            <Col lg={8} md={8}>
                { renderCurrentState() }
            </Col>
        </Row>
    </div>;

};

export default ContactUs;